import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';

const apiUrl = GlobalConstants.apiURL

@Injectable({
  providedIn: 'root'
})
export class LabService {

  constructor(private http:HttpClient, private sharedapi:SharedService) { }

    addLead(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'add-lab-lead',data,{headers:webheader})
    }

    addLeadByAgent(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'add-lab-lead-by-agent',data,{headers:webheader})
    }

    addSubCategory(data)
    {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-sub-category',data,{headers:webheader})
    }

    addCategory(data)
    {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'add-category',data,{headers:webheader})
    }

    getLabTestCategory()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lab-test-category',{headers:webheader})
    }

    getLabTestSubcategory()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lab-test-subcategory',{headers:webheader})
    }

    getLabTestCategorySubcategory(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lab-test-category-subcategory?'+data,{headers:webheader})
    }

    getLabBds()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-bds-of-lab',{headers:webheader})
    }

    getLabLeadsSheet(pageno,limit,qstring)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lab-leads-sheet/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
    }

    getLabCommonData()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lab-common-data',{headers:webheader})
    }

    getLabCommonDataForFilter()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lab-common-data-for-filter',{headers:webheader})
    }

    updateSingleData(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.put(apiUrl+'save-lab-single-data',data,{headers:webheader})
    }

    getLabLeadDetails(data)
    {
        let lead_id = data.lead_id.id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lab-lead-details/'+lead_id,{headers:webheader})
    }


    updateLabLead(data,LeadData)
    {
        let lead_id = data.lead_id.id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'update-lab-lead/'+lead_id,LeadData,{headers:webheader})
    }

    getLabLeadStatus()
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lab-lead-status',{headers:webheader})
    }

    uploadcsvLabTest(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-lab-test',data,{headers:webheader})
    }

    getFullLabLeadHistory(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-full-lab-lead-history/'+lead_id,{headers:webheader})
    }

    uploadLabFile(data,formData)
    {
        let lead_id = data.lead_id.id;
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'upload-lab-docs/'+lead_id,formData,{headers:webheader})
    }


    deleteLabTestFiles(fileId)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.delete(apiUrl+'delete-lab-test-file/'+fileId,{headers:webheader})
    }


    addLab(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-lab',data,{headers:webheader})
  }

  uploadLabDocs(lab_id, formData)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'upload-lab-documents/'+lab_id,formData,{headers:webheader})
  }

  deleteLabFiles(fileId)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.delete(apiUrl+'delete-lab-document/'+fileId,{headers:webheader})
  }

  getLabList(pageno,limit,qstring)
  {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lab-list/'+limit+'/'+pageno+'?'+qstring,{headers:webheader})
  }

  updateLabStatus(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-lab-status',data,{headers:webheader})
  }

  updateLab(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-lab-data',data,{headers:webheader})
  }

  getLabData(data){
    let lab_id = data;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-lab-data/'+ lab_id, {headers:webheader})
  }

    nimbusClickTOCallForLabLeads(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'nimbus-click-to-call-for-lab-leads',lead_id,{headers:webheader})
    }


    kaleyraClickTOCall(lead_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'kaleyra-click-to-call-for-lab-leads',lead_id,{headers:webheader})
    }

    kaleyraEndClicktoCall(response_call_id)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'kaleyra-end-click-to-call-for-lab-leads',response_call_id,{headers:webheader})
    }

    uploadcsvLabLeads(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'import-lab-leads-csv',data,{headers:webheader})
    }

    addMoveLeadToLead(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'add-move-lead-to-lead',data,{headers:webheader})
    }

    getLabLeadRecord(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.get(apiUrl+'get-lab-lead-details/'+data,{headers:webheader})
    }

    checkLabLeadMobileNumber(data)
    {
        let webheader = this.sharedapi.getHeaders();
        return this.http.post(apiUrl+'check-lab-lead-mobile-already-exists',data,{headers:webheader})
    }

}
